(() => {
  if (document.documentElement.hasAttribute('data-op-review-skin')) return;
  document.documentElement.setAttribute('data-op-review-skin', '');
  const script = document.querySelector('script[data-op-review-portraits]');
  const portrait = script?.dataset.opReviewPortraits || '';
  const records = new Map();
  let names = [];
  let rating;
  function refreshReviewHeading(record) {
    const section = record.frame.closest('.op-live-reviews');
    const original = record.doc?.querySelector('#tp-widget-profile-link, #wrapper-company-info');
    const sourceStars = original?.querySelector('.tp-widget-stars svg');
    if (!section || !rating || !sourceStars) return;
    const heading = section.querySelector('h2');
    if (!heading) return;
    const signature = JSON.stringify(rating);
    if (record.headingSignature === signature) return;
    record.headingSignature = signature;
    heading.textContent = 'Eure Setups. ';
    const gradient = document.createElement('span');
    gradient.className = 'op-review-heading-gradient'; gradient.textContent = 'Eure Meinung.';
    heading.append(gradient);
    if (!section.querySelector('.op-review-eyebrow')) {
      const eyebrow = document.createElement('p');
      eyebrow.className = 'op-review-eyebrow'; eyebrow.textContent = 'EURE ERFAHRUNGEN';
      heading.before(eyebrow);
      const subtitle = document.createElement('p');
      subtitle.className = 'op-review-subtitle'; subtitle.textContent = 'Eure Meinung ist uns wichtig';
      heading.after(subtitle);
    }
    const summary = document.createElement('a');
    summary.className = 'op-review-summary'; summary.href = rating.profile;
    summary.target = '_blank'; summary.rel = 'noopener';
    const stars = sourceStars.cloneNode(true);
    stars.removeAttribute('style'); stars.removeAttribute('id');
    stars.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));
    const sourcePaths = [...sourceStars.querySelectorAll('path')];
    stars.querySelectorAll('path').forEach((e,i)=>e.setAttribute('fill',record.doc.defaultView.getComputedStyle(sourcePaths[i]).fill));
    const score = document.createElement('span'); score.className = 'op-review-summary__score';
    const strong = document.createElement('strong'); strong.textContent = rating.score.toLocaleString('de-DE',{minimumFractionDigits:1,maximumFractionDigits:1});
    score.append(strong,document.createTextNode(' / 5'));
    const count = document.createElement('span'); count.className = 'op-review-summary__count';
    count.textContent = rating.count.toLocaleString('de-DE')+' '+(rating.count===1?'Bewertung':'Bewertungen')+' auf Trustpilot';
    summary.append(stars,score,count);
    section.querySelector('.op-review-summary')?.remove();
    section.querySelector('.op-review-subtitle').after(summary);
    original.style.setProperty('display','none','important');
  }
  const frameCss = `
    #tp-widget-wrapper{height:auto!important;min-height:0!important;position:relative!important;box-sizing:border-box!important}
    html,body{background:transparent!important;font-family:Arial,sans-serif!important;color:#0f161f!important}
    #tp-widget-reviews-filter-label{display:none!important}
    .tp-widget-review{background:#fff!important;border:1px solid #ded8f0!important;border-radius:16px!important;padding:22px!important;box-shadow:0 5px 20px #483b7510!important;box-sizing:border-box!important;text-align:left!important}
    .tp-widget-review .header{font-size:16px!important;line-height:1.4!important;color:#0f161f!important;margin:16px 0 10px!important}
    .tp-widget-review .text{font-size:14px!important;line-height:1.75!important;color:#465161!important}
    .tp-widget-review .secondary-text{color:#697384!important;font-size:12px!important}
    .tp-widget-review__user-name{font-weight:700!important;color:#6048d2!important}
    #wrapper-reviews{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:18px!important;padding:8px 0 16px!important}
    #wrapper-reviews>.tp-widget-reviewcolumn{width:auto!important;padding:0!important;margin:0!important;float:none!important;min-width:0!important}
    #wrapper-reviews .tp-widget-review{height:100%!important;margin:0!important}
    #wrapper-company-info{margin-bottom:24px!important}
    .tp-widget-review .tp-widget-stars{max-width:120px!important}
    #tp-widget-wrapper.op-review-cards-ready>:not(#op-review-cards):not(.op-review-slider-controls){display:none!important}
    #op-review-cards{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));align-items:start;gap:18px;padding:8px 2px 12px;box-sizing:border-box}
    #op-review-cards .op-review-card{align-self:start;width:100%!important;min-width:0!important;min-height:var(--op-review-card-height,276px)!important;height:auto!important;margin:0!important;padding:20px!important;overflow:visible!important;float:none!important;position:relative!important}
    #op-review-cards .header{display:-webkit-box!important;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:42px;margin:14px 0 10px!important;font-size:15px!important}
    #op-review-cards .date-and-user-info-wrapper{display:flex;flex-wrap:wrap;gap:4px 8px;margin-top:12px}
    #op-review-cards .op-review-body{font-size:14px;line-height:1.65;color:#465161;overflow-wrap:anywhere;white-space:pre-line}
    #op-review-cards .op-review-preview{margin:0;min-height:92px;white-space:normal}
    #op-review-cards .op-review-expand{margin-top:10px}
    #op-review-cards .op-review-expand summary{display:flex;align-items:center;justify-content:space-between;gap:8px;min-height:38px;color:#6048d2;font-size:12px;font-weight:600;cursor:pointer;list-style:none}
    #op-review-cards .op-review-expand summary::-webkit-details-marker{display:none}
    #op-review-cards .op-review-expand summary:after{content:'⌄';font-size:19px;transition:transform .2s}
    #op-review-cards .op-review-expand[open] summary:after{transform:rotate(180deg)}
    #op-review-cards .op-review-expand p{margin:10px 0 0;white-space:pre-line}
    #op-review-cards .op-review-body:has(.op-review-expand[open])>.op-review-preview{display:none}
    .op-review-slider-controls{display:none}
    @media(max-width:749px){
      #op-review-cards{display:flex;align-items:flex-start;gap:12px;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;overscroll-behavior-x:contain;scrollbar-width:thin;scrollbar-color:#9a82ef #e8e2f4;padding:8px 2px 14px}
      #op-review-cards::-webkit-scrollbar{height:4px}
      #op-review-cards::-webkit-scrollbar-track{background:#e8e2f4;border-radius:4px}
      #op-review-cards::-webkit-scrollbar-thumb{background:#9a82ef;border-radius:4px}
      #op-review-cards .op-review-card{flex:0 0 88%;scroll-snap-align:start;padding:18px!important}
      .op-review-expand summary:focus-visible{outline:2px solid #795bff;outline-offset:3px}
    }
    @media(prefers-reduced-motion:reduce){#op-review-cards{scroll-behavior:auto}.op-review-expand summary:after{transition:none}}
  `;
  function refreshReviewCards(record) {
    const {doc,frame}=record;
    if (!frame.closest('.op-live-reviews')) return;
    const wrapper=doc.getElementById('tp-widget-wrapper');
    if (!wrapper) return;
    const originals=[...wrapper.querySelectorAll('.tp-widget-review')].filter(card=>!card.closest('#op-review-cards'));
    if (!originals.length) return;
    const signature=originals.map(card=>card.textContent).join('\n');
    if (record.cardsSignature===signature) return;
    record.cardsSignature=signature;
    const cards=doc.createElement('div');cards.id='op-review-cards';
    cards.setAttribute('role','region');cards.setAttribute('aria-label','Kundenbewertungen');cards.tabIndex=0;
    for (const original of originals) {
      const card=original.cloneNode(true);card.classList.add('op-review-card');card.removeAttribute('style');
      card.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
      const source=original.querySelector('.text');
      const full=source?.innerText.trim() || '';
      card.querySelectorAll('.text,.read-more').forEach(node=>node.remove());
      if (full) {
        const body=doc.createElement('div');body.className='op-review-body';
        const chars=Array.from(full);
        const preview=doc.createElement('p');preview.className='op-review-preview';
        preview.textContent=chars.length>150 ? chars.slice(0,150).join('').replace(/\s+/g,' ').trimEnd()+'…' : full;
        body.append(preview);
        if (chars.length>150) {
          const details=doc.createElement('details');details.className='op-review-expand';
          const summary=doc.createElement('summary');summary.textContent='Gesamte Bewertung lesen';
          const text=doc.createElement('p');text.textContent=full;
          details.append(summary,text);body.append(details);
          details.addEventListener('toggle',()=>{
            if(details.open){
              cards.querySelectorAll('details[open]').forEach(other=>{if(other!==details)other.open=false;});
              record.expandedScrollLeft=cards.scrollLeft;
            }
            schedule(record);
          });
        }
        card.append(body);
      }
      cards.append(card);
    }
    doc.getElementById('op-review-cards')?.remove();
    wrapper.querySelector('.op-review-slider-controls')?.remove();
    wrapper.append(cards);wrapper.classList.add('op-review-cards-ready');
    cards.addEventListener('scroll',()=>{
      if(doc.defaultView.matchMedia('(max-width:749px)').matches && Math.abs(cards.scrollLeft-(record.expandedScrollLeft??cards.scrollLeft))>12){
        cards.querySelectorAll('details[open]').forEach(details=>{details.open=false;});
        schedule(record);
      }
    },{passive:true});
    let measuredWidth=0;
    const sizeCards=()=>{
      if(Math.abs(cards.clientWidth-measuredWidth)>1){
        measuredWidth=cards.clientWidth;
        cards.querySelectorAll('details[open]').forEach(details=>{details.open=false;});
        cards.style.removeProperty('--op-review-card-height');
        const height=Math.ceil(Math.max(...[...cards.children].map(card=>card.getBoundingClientRect().height)));
        cards.style.setProperty('--op-review-card-height',height+'px');
      }
      schedule(record);
    };
    sizeCards();
    record.cardsResize?.disconnect();
    record.cardsResize=new ResizeObserver(sizeCards);record.cardsResize.observe(wrapper);
  }
  function safeProfile(value) {
    try { const u = new URL(value); return /(^|\.)trustpilot\.com$/.test(u.hostname) && u.protocol === 'https:' ? u.href : null; } catch { return null; }
  }
  function refreshCompact(record) {
    const {frame, doc} = record;
    const parent = frame.closest('.op-intro__live-rating, .product-details .shopify-app-block');
    if (!parent) return;
    const countText = doc.querySelector('#businessEntity-numberOfReviews-total')?.textContent.trim();
    const scoreText = doc.querySelector('#trust-score')?.textContent.trim();
    const profile = safeProfile(doc.querySelector('#profile-link')?.href);
    if (!/^\d+$/.test(countText || '') || !profile || !/^\d(?:[.,]\d+)?$/.test(scoreText || '')) return;
    const count = Number(countText), score = Number(scoreText.replace(',', '.'));
    if (!Number.isSafeInteger(count) || count < 1 || score < 0 || score > 5) return;
    rating = {count,score,profile};
    for (const r of records.values()) if (r.doc) refreshReviewHeading(r);
    const signature = JSON.stringify([count,score,profile,names]);
    if (record.signature === signature) return;
    record.signature = signature;
    const link = document.createElement('a');
    link.className = 'op-review-compact';
    link.href = profile; link.target = '_blank'; link.rel = 'noopener';
    const faces = document.createElement('span');
    faces.className = 'op-review-compact__faces'; faces.setAttribute('aria-hidden','true');
    for (let i=0;i<3;i++) {
      const face = document.createElement('span'); face.className = 'op-review-compact__face';
      if (portrait) {
        const img = document.createElement('img'); img.src = portrait; img.alt = '';
        img.width=384; img.height=57; img.style.left = -(18+i*22)+'px'; face.append(img);
      } else { face.textContent = names[i]?.slice(0,1) || '•'; }
      faces.append(face);
    }
    const copy = document.createElement('span'); copy.className = 'op-review-compact__copy';
    const stars = document.createElement('span'); stars.className='op-review-compact__stars';
    stars.textContent = '★'.repeat(Math.floor(score))+'☆'.repeat(5-Math.floor(score));
    stars.setAttribute('role','img'); stars.setAttribute('aria-label',score+' von 5 Sternen auf Trustpilot');
    const sourceStars = doc.querySelector('.tp-widget-stars svg');
    if (sourceStars) {
      const svg = sourceStars.cloneNode(true);
      svg.removeAttribute('style'); svg.removeAttribute('id');
      svg.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
      const paths = [...sourceStars.querySelectorAll('path')];
      svg.querySelectorAll('path').forEach((node,i)=>node.setAttribute('fill',doc.defaultView.getComputedStyle(paths[i]).fill));
      stars.replaceChildren(svg);
    }
    const text = document.createElement('span'); text.className='op-review-compact__text';
    const name = names[0];
    const total = count.toLocaleString('de-DE');
    text.textContent = parent.closest('.product-details')
      ? (name ? name+' und '+total+'+ andere lieben unsere Mauspads' : total+'+ Kunden lieben unsere Mauspads')
      : (name ? 'Gefällt '+name+' und '+total+'+ anderen' : 'Gefällt '+total+'+ Kunden');
    copy.append(stars,text); link.append(faces,copy);
    parent.querySelector('.op-review-compact')?.remove(); parent.append(link);
    parent.classList.add('op-review-compact-host');
    frame.setAttribute('aria-hidden','true'); frame.setAttribute('tabindex','-1');
  }
  function update(record) {
    const {frame}=record;
    let doc;
    try { if (new URL(frame.src,location.href).origin !== location.origin) return; doc=frame.contentDocument; } catch { return; }
    if (!doc?.body) return;
    record.doc=doc;
    if (record.observedDoc !== doc) {
      record.inner?.disconnect(); record.observedDoc=doc;
      record.inner=new MutationObserver(()=>schedule(record));
      record.inner.observe(doc.body,{childList:true,subtree:true,characterData:true});
    }
    if (!doc.getElementById('op-review-frame-style')) {
      const style=doc.createElement('style');style.id='op-review-frame-style';style.textContent=frameCss;doc.head.append(style);
    }
    const users=[...doc.querySelectorAll('.tp-widget-review__user-name, .name.secondary-text')].filter(e=>!e.closest('#op-review-cards')).map(e=>e.textContent.replace(/[,\s]+$/,'').trim().split(' ')[0]).filter(Boolean);
    if (users.length) {
      const next=[...new Set(users)].slice(0,3);
      if (JSON.stringify(next)!==JSON.stringify(names)) { names=next; for(const r of records.values()) if(r.doc) refreshCompact(r); }
    }
    const label=doc.getElementById('tp-widget-reviews-filter-label');
    const section=frame.closest('.op-live-reviews');
    if (label && section && !section.querySelector('.op-review-selection')) {
      const note=document.createElement('a');note.className='op-review-selection';
      note.textContent='Alle Bewertungen auf Trustpilot angucken';
      note.href='https://de.trustpilot.com/review/onlypads.de';note.target='_blank';note.rel='noopener';
      section.querySelector('.op-live-reviews__inner')?.append(note);
    }
    refreshCompact(record);
    refreshReviewHeading(record);
    refreshReviewCards(record);
    if (section && doc.querySelector('.tp-widget-review')) {
      const h=Math.ceil(doc.getElementById('tp-widget-wrapper')?.getBoundingClientRect().height || doc.body.scrollHeight)+28;
      if(h>100 && Math.abs(frame.getBoundingClientRect().height-h)>2) frame.style.height=h+'px';
    }
  }
  function schedule(record) { if(record.pending)return;record.pending=requestAnimationFrame(()=>{record.pending=0;update(record);}); }
  function scan() {
    for(const [frame,r] of records)if(!frame.isConnected){r.inner?.disconnect();r.resize?.disconnect();r.cardsResize?.disconnect();records.delete(frame);}
    for(const frame of document.querySelectorAll('iframe[src*="/a/tv-reviews/"]')) {
      if(records.has(frame))continue;
      const record={frame};records.set(frame,record);
      frame.addEventListener('load',()=>schedule(record));
      record.resize=new ResizeObserver(()=>schedule(record));record.resize.observe(frame);
      schedule(record);
    }
  }
  const outer=new MutationObserver(scan);outer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src']});scan();
  window.addEventListener('pagehide',()=>{outer.disconnect();for(const r of records.values()){r.inner?.disconnect();r.resize?.disconnect();r.cardsResize?.disconnect();if(r.pending)cancelAnimationFrame(r.pending);}records.clear();},{once:true});
})();



